const isProd = process.env.NODE_ENV === "production" || process.env.REACT_APP_ENV === "STAGING"

export const log = isProd ? () => undefined : console.log
export const warn = isProd ? () => undefined : console.warn
export const error = isProd ? () => undefined : console.error
